<template>
  <div class="news">
    <div class="contentCenter">
      <nav class="currentLocation">
        <ul class="display-flex">
          <li>
            <span>您的位置</span>
          </li>
          <li>
            <span>新闻资讯</span>
          </li>
        </ul>
      </nav>
      <div class="newsList">
        <div style="width: 1200px; float: left;">
          <ul class="list">
            <li style="cursor: pointer;" v-for="item in list" :key="item.id" class="display-flex"  @click="linltoDetail(item)">
              <img :src="item.fmurl" alt="" />
              <!-- onerror="javascript:this.src='../assets/images/proof.jpg'" -->
              <div class="text flex-1">
                <div
                  class="title display-flex justify-content-space-between align-items-center"
                >
                  <h4>{{ item.title }}</h4>
                  <span class="time"
                    >发布时间<i>{{ item.createtime.split(" ")[0] }}</i></span
                  >
                </div>
                <p>{{ item.desc }}</p>
                <div class="browseCount">
                  浏览量 <span> {{ item.browsenum }}</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="page">
            <Page
              v-if="totalPage > 0"
              :total="totalPage"
              show-elevator
              show-total
              class-name="pageItem"
              @on-change="handleChangePage"
            >
            </Page>
          </div>
        </div>
        <!-- <div class="otherNews">
          <div
            class="publicTitle display-flex justify-content-space-between align-items-center"
          >
            <h5 class="h5">
              <img src="../assets/img/titleLine.png" alt /> 相关阅读
            </h5>
          </div>
          <ul class="otherList">
            <li>
              <h5>
                考前冲刺! 2019一级消防2019一级消防2019一级消防2019一级消防
              </h5>
              <div
                id="footer"
                class="display-flex justify-content-space-between align-items-center"
              >
                <div class="browseCount">浏览量 <span> 4564254</span></div>
                <div class="time">2020-04-03</div>
              </div>
            </li>
            <li>
              <h5>
                考前冲刺! 2019一级消防2019一级消防2019一级消防2019一级消防
              </h5>
              <div
                id="footer"
                class="display-flex justify-content-space-between align-items-center"
              >
                <div class="browseCount">浏览量 <span> 4564254</span></div>
                <div class="time">2020-04-03</div>
              </div>
            </li>
            <li>
              <h5>
                考前冲刺! 2019一级消防2019一级消防2019一级消防2019一级消防
              </h5>
              <div
                id="footer"
                class="display-flex justify-content-space-between align-items-center"
              >
                <div class="browseCount">浏览量 <span> 4564254</span></div>
                <div class="time">2020-04-03</div>
              </div>
            </li>
            <li>
              <h5>
                考前冲刺! 2019一级消防2019一级消防2019一级消防2019一级消防
              </h5>
              <div
                id="footer"
                class="display-flex justify-content-space-between align-items-center"
              >
                <div class="browseCount">浏览量 <span> 4564254</span></div>
                <div class="time">2020-04-03</div>
              </div>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
    <!--<ContactWay />-->
  </div>
</template>

<script>
import ContactWay from "@/components/ContactWay.vue";
import { postData, showLoading } from "../assets/api/api.js";
export default {
  name: "news",
  components: { ContactWay },
  data() {
    return {
      page: 0,
      size: 10,
      totalPage: 0,
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    handleChangePage(page) {
      this.page = page - 1;
      this.loadData();
    },
    loadData() {
      const { page, size } = this;
      var params = {
        currentPage: page,
        pageSize: size,
      };
      showLoading();
      postData("article/listPage", params).then((res) => {
        if (res.data) {
          if (res.data.entities) {
            this.list = res.data.entities;
            this.totalPage = res.data.pageCount;
          } else {
            this.list = [];
          }
        } else {
          this.list = [];
        }
      });
    },
    linltoDetail(item) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: item.id },
      });
    },
  },
};
</script>
<style>
/* .contact {
  padding-top: 5px;
  background: #fff;
  position: absolute;
  right: -80px;
  top: 55px !important;
} */
</style>
<style lang="scss" scoped>
.news {
  .page {
    text-align: center;
    margin-bottom: 30px;
  }
  .newsList {
    overflow: hidden;
    .browseCount {
      line-height: 15px;
      margin-top: 16px;
      color: rgba(170, 170, 170, 1);
      span {
        margin-left: 20px;
      }
    }
    .otherList {
      li {
        padding-left: 20px;
        padding-right: 20px;
        border-bottom: 1px solid #f3f3f5;
        padding-bottom: 10px;
        padding-top: 10px;
        h5:hover {
          color: #37bc5f;
          cursor: pointer;
        }
        h5 {
          width: 90%;
          font-size: 17px;
          line-height: 20px;
          color: rgba(34, 34, 34, 1);
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          overflow: hidden;
        }
        #footer {
          .time {
            margin-top: 16px;
            line-height: 15px;
            color: #aaaaaa;
          }
        }
      }
    }
    .list {
      margin-bottom: 35px;
      background: #fff;
      li {
        border-bottom: 1px solid #f3f3f5;
        padding: 20px 30px 20px 20px;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          color: #999999;
          line-height: 18px;
        }

        .title {
          margin-bottom: 12px;
          .time {
            i {
              margin-left: 25px;
            }
            color: #cccccc;
          }

          h4 {
            cursor: pointer;
            width: 343px;
            font-size: 18px;
            color: rgba(22, 26, 33, 1);
            line-height: 20px;
            width: 340px;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            overflow: hidden;
          }
        }
        img {
          margin-right: 20px;
          width: 180px;
          height: 100px;
        }
      }
    }
    .otherNews {
      float: right;
      width: 280px;
      background: #fff;
    }
  }
}
</style>
